export class ActivityDataModel {
    type: ActivityType | undefined;
    data: any | undefined;
}

export enum ActivityType{
    post = "post",
    commentCount = "comment-count",
    reactionCount = "reaction-count",
    repostCount = "repost-count",
    pollChartCount = "poll-chart-count"
}